<div class="progress container" *ngIf="showProgress">
  <p-progressSpinner class="progress-spinner"  styleClass="progress-spinner axks-progress-spinner" strokeWidth="8"></p-progressSpinner>
</div>
<ng-container *ngIf="loadContent">
  <router-outlet></router-outlet>
</ng-container>
